// React
import React from 'react';
// Internal
import ContainerRounded from 'components/shared/atoms/ContainerRounded/ContainerRounded';
// Styles
import './styles.scss';

/**
 * @param {Object} props.style - Style to applied to the component, this overwrites the height and width props
 * @param {string} props.className - className to applied to the component
 * @param {string} props.headerTitle - Text to displayed in the headerTitle
 * @param {string} props.headerBtnText - Text to displayed in the header button
 * @param {string} props.headerSubComponent - A sub component to place under the header title row
 * @param {string} props.headerStyle - Style to applied to the header
 * @param {Function} props.to - Path or Route object to navigate to
 * @param {boolean} props.divider - Boolean to display the divider between header and body, default is true.
 */
class ContentCard extends React.Component {
    constructor(props) {
        super(props);
        this.style = props.style ? props.style : {};
        this.divider = typeof props.divider === 'boolean' && props.divider !== undefined ? props.divider : true;
    }

    render() {
        return (
            <ContainerRounded className={this.props.className} style={this.props.style}>
                {this.props.headerSubComponent}
                {this.props.children}
            </ContainerRounded>
        );
    }
}

export default ContentCard;
